module.exports = __webpack_public_path__ + "img/banner-15.debcc8c2.jpg";